import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface BoardWriteButtonProps {
  to: string;
  children?: ReactNode;
}

/** hero 오른쪽(검색창 옆)에 두는 작성 버튼. 게시판 목록·FAQ 공용 */
export function BoardWriteButton({ to, children = '글쓰기' }: BoardWriteButtonProps) {
  return (
    <Link
      to={to}
      className="inline-flex h-10 items-center gap-1.5 rounded-full bg-neutral-950 px-4 text-[13px] font-semibold text-white transition-opacity hover:opacity-80 dark:bg-white dark:text-neutral-950"
    >
      {children}
    </Link>
  );
}
